export const validateEmail = (email: string) => {
  const emailRegEx = /\S+@\S+\.\S+/

  if (emailRegEx.test(email)) {
    return true
  }
  return false
}
